export var Card = {
  baseStyle: {
    container: {
      borderRadius: '.187rem'
    }
  }
};